import React, {useRef, useState} from 'react';
import { LogoutButton } from './LogoutButton';
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getUserData, loginUser } from 'src/thunks/authThunk';

function Login() {
    const emailRef = useRef();
    const passwordRef = useRef();

    const dispatch = useDispatch();
    const authStatus = useSelector((state) => state.auth.status);
    const authError = useSelector((state) => state.auth.error);
    const authUser = useSelector((state) => state.auth.user);
    const authUsername = useSelector((state) => state.auth.userData?.username);

    const navigate = useNavigate();
    const location = useLocation();

    const redirectTo = location.state?.from?.pathname || null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        dispatch(loginUser({email:emailRef.current.value, password:passwordRef.current.value}));
        // try
        //     await login(emailRef.current.value, passwordRef.current.value);
        //     setLoginError(null);
        //     if(redirectTo != null){
        //         navigate(redirectTo);
        //     }
        // }
        // catch(error){
        //     setLoginError("Failed to login: " + error);
        //     console.error("Failed to log in", error);
        // }
    }

    return (<>
    <div>
        {redirectTo}
        <h2>Login</h2>
        {authUser && <>
            <p>Logged in as {authUser.email}</p>
            <p>username: {authUsername}</p>
            <LogoutButton/>
            </>}
            {authError && <p>{authError}</p>}
        {!authUser && 
            <form onSubmit={handleSubmit}>
            <input type='email' ref={emailRef} required placeholder='Email'/>
            <input type='password' ref={passwordRef} required placeholder='Password'/>
            <button type="submit">Login</button>
        </form>
        }
        
    </div>
    </>)
}

export default Login;